import { CmsProtectionDetailsPage } from '../../models/protection-details/cms-protection-details-page.type';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsProtectionBenefitsAccordion } from './cms-protection-benefits-accordion.mock';
import { mockCmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.mock';
import { mockCmsProtectionDetails } from './cms-protection-details.mock';

export const mockCmsProtectionDetailsPage: CmsProtectionDetailsPage = {
  ...mockCmsProtectionBenefitsAccordion,
  ...mockCmsProtectionDetails,
  ...mockCmsRegistrationRoot,
  ...mockCmsProtectionDetailsUpsellModal,
  pageTitle: 'pageTitle',
  promotionalPrice: false,
  protectionDetailsTermsAndConditions: 'protectionDetailsTermsAndConditions',
};
